import { render, staticRenderFns } from "./LeaderSelect.vue?vue&type=template&id=06a4e79c"
import script from "./LeaderSelect.vue?vue&type=script&lang=js"
export * from "./LeaderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports